module.exports = __webpack_public_path__ + "img/refund-approve.cb4342a1.svg";